import { Checkbox } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";
import { TestsBySection } from "../../../models/TestsBySection";

export type CheckboxCellContext = {
	onToggle: (row: TestsBySection, field: keyof TestsBySection) => void;
	onEdit: (row: TestsBySection) => void;
	onDelete: (row: TestsBySection) => void;
	isEditMode: boolean;
	isSubmitLoading: boolean;
};

export const CheckboxCell = (params: ICellRendererParams<TestsBySection>) => {
	const field = params.colDef?.field as keyof TestsBySection;
	const { onToggle, isEditMode, isSubmitLoading } =
		(params.context as CheckboxCellContext) ?? {};

	return (
		<Checkbox
			checked={!!params.value}
			disabled={!isEditMode || isSubmitLoading}
			onChange={() => params.data && onToggle?.(params.data, field)}
			size="small"
			color="primary"
			sx={{ p: 0 }}
		/>
	);
};
